module.exports = __webpack_public_path__ + "img/ic_chat.718c117c.svg";